<mat-card class="shadow-none bg-transparent">
  <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
    <div>
      <a class="d-flex m-0 align-items-center" [href]="youtubeReviewLink" target="_blank">
        <img class="me-2 ic-img" src="/assets/svgs/icons/ic_youtube.svg" alt="integration review" />
        <span>{{ 'integration_review' | translate }}</span>
      </a>
    </div>
  </mat-card-content>
</mat-card>

